var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: _vm.dialogTitle,
            width: "910px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }),
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c("div", { staticClass: "flex-box" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _vm.$store.getters.curCountry.country_code !==
                                  "TH" ||
                                _vm.form.beneficiary_account_type !==
                                  "PROMPTPAY"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "merchantAccount.recipient_channel"
                                          ),
                                          prop: "disbursement_channel",
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                "Receiving channel cannot be empty",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "select-item",
                                            attrs: {
                                              placeholder:
                                                "Select receiving channel",
                                              filterable: "",
                                              clearable: "",
                                            },
                                            on: {
                                              change:
                                                _vm.disbursementChannelChange,
                                            },
                                            model: {
                                              value:
                                                _vm.form.disbursement_channel,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "disbursement_channel",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.disbursement_channel",
                                            },
                                          },
                                          _vm._l(
                                            _vm.bankList,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    item.name_with_full_bank,
                                                  value: item.bank_code,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.showBeneficiaryAccountType
                        ? _c("div", { staticClass: "flex-box" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 11 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "merchantAccount.beneficiary_account_type"
                                          ),
                                          prop: "beneficiary_account_type",
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                "Beneficiary account type cannot be empty",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "select-item",
                                            attrs: {
                                              placeholder:
                                                "Select beneficiary account type",
                                              filterable: "",
                                            },
                                            on: {
                                              change:
                                                _vm.beneficiaryAccountTypeChange,
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .beneficiary_account_type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "beneficiary_account_type",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.beneficiary_account_type",
                                            },
                                          },
                                          _vm._l(
                                            _vm.beneficiaryAccountType,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.showBeneficiaryType
                        ? _c("div", { staticClass: "flex-box" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 11 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.beneficiaryTypeLabel,
                                          prop: "beneficiary_type",
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                "Beneficiary type cannot be empty",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "select-item",
                                            attrs: {
                                              placeholder:
                                                "Select beneficiary type",
                                              filterable: "",
                                              clearable: "",
                                            },
                                            on: {
                                              change: _vm.beneficiaryTypeChange,
                                            },
                                            model: {
                                              value: _vm.form.beneficiary_type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "beneficiary_type",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.beneficiary_type",
                                            },
                                          },
                                          _vm._l(
                                            _vm.beneficiaryTypeOptions,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                  alt: item.label,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "flex-box" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "merchantAccount.recipient_name"
                                      ),
                                      prop: "disbursement_name",
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Recipient name cannot be empty",
                                          trigger: "blur",
                                        },
                                        {
                                          validator: _vm.checkWhitespace,
                                          trigger: "blur",
                                        },
                                        {
                                          validator: _vm.checkName,
                                          trigger: "blur",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "search-frame",
                                      attrs: {
                                        placeholder: "Enter recipient name",
                                        maxlength: "100",
                                        autocomplete: "off",
                                        clearable: "",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.form.disbursement_name,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "disbursement_name",
                                            $$v
                                          )
                                        },
                                        expression: "form.disbursement_name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "flex-box" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "send_pagements.recipient_account_number"
                                      ),
                                      prop: "disbursement_number",
                                      rules: [
                                        {
                                          required: true,
                                          message:
                                            "Recipient account number cannot be empty",
                                          trigger: ["blur", "change"],
                                        },
                                        {
                                          validator: _vm.checkoutAccountNo,
                                          trigger: ["blur", "change"],
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "search-frame",
                                      attrs: {
                                        placeholder:
                                          "Enter recipient account number",
                                        maxlength: "50",
                                        autocomplete: "off",
                                        clearable: "",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.form.disbursement_number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "disbursement_number",
                                            $$v
                                          )
                                        },
                                        expression: "form.disbursement_number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "flex-box" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "merchantAccount.short_name"
                                      ),
                                      prop: "disbursement_short_name",
                                      rules: [
                                        {
                                          required: true,
                                          message: "Short name cannot be empty",
                                          trigger: ["blur", "change"],
                                        },
                                        {
                                          validator: _vm.checkWhitespace,
                                          trigger: "blur",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "search-frame",
                                      attrs: {
                                        placeholder: "Fill in the short name",
                                        maxlength: "64",
                                        autocomplete: "off",
                                        clearable: "",
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.form.disbursement_short_name,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "disbursement_short_name",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.disbursement_short_name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.isGulfCountry
                        ? [
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_iban"
                                            ),
                                            prop: "iban",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "Beneficiary IBAN cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder:
                                                "Enter beneficiary IBAN",
                                              autocomplete: "off",
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.iban,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "iban",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.iban",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_swift_code"
                                            ),
                                            prop: "swift_code",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "SWIFT Code cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder: "Enter SWIFT code",
                                              autocomplete: "off",
                                              maxlength: "50",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.swift_code,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "swift_code",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "form.swift_code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_bank_address"
                                            ),
                                            prop: "bank_address",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "Beneficiary bank address cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder:
                                                "Enter beneficiary bank address",
                                              autocomplete: "off",
                                              maxlength: "200",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.bank_address,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "bank_address",
                                                  $$v
                                                )
                                              },
                                              expression: "form.bank_address",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_en_first_name"
                                            ),
                                            prop: "en_first_name",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "Beneficiary English first name cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder:
                                                "Enter beneficiary English first name",
                                              autocomplete: "off",
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.en_first_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "en_first_name",
                                                  $$v
                                                )
                                              },
                                              expression: "form.en_first_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_en_last_name"
                                            ),
                                            prop: "en_last_name",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "Beneficiary English last name cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder:
                                                "Enter beneficiary English last name",
                                              autocomplete: "off",
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.en_last_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "en_last_name",
                                                  $$v
                                                )
                                              },
                                              expression: "form.en_last_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_native_first_name"
                                            ),
                                            prop: "local_first_name",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "Beneficiary native first name cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder:
                                                "Enter beneficiary native first name",
                                              autocomplete: "off",
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.local_first_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "local_first_name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.local_first_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "flex-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 11 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "merchantAccount.beneficiary_native_last_name"
                                            ),
                                            prop: "local_last_name",
                                            rules: [
                                              {
                                                required: true,
                                                message:
                                                  "Beneficiary native last name cannot be empty",
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "search-frame",
                                            attrs: {
                                              placeholder:
                                                "Enter beneficiary native last name",
                                              autocomplete: "off",
                                              maxlength: "100",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.local_last_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "local_last_name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.local_last_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      _vm.$store.getters.curCountry.country_code === "AE"
                        ? _c("div", { staticClass: "flex-box" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 11 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("map.benefit_address"),
                                          prop: "beneficiary_address",
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                "Beneficiary address cannot be empty",
                                              trigger: ["blur", "change"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "tips.beneficiary_address_name_exceed_140"
                                            ),
                                            type: "textarea",
                                            rows: 3,
                                            autocomplete: "off",
                                            maxlength: "140",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value: _vm.form.beneficiary_address,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "beneficiary_address",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.beneficiary_address",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.$store.getters.curCountry.country_code === "TH"
                        ? _c("div", { staticClass: "flex-box" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 11 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "merchantAccount.beneficiary_mobile"
                                          ),
                                          prop: "beneficiary_mobile",
                                          rules: [
                                            {
                                              validator: _vm.checkMobile,
                                              trigger: ["blur", "change"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "search-frame",
                                          attrs: {
                                            placeholder:
                                              "Enter beneficiary mobile",
                                            autocomplete: "off",
                                            clearable: "",
                                            maxlength: "10",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value: _vm.form.beneficiary_mobile,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "beneficiary_mobile",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "form.beneficiary_mobile",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("customerService.attachments") + ":",
                                prop: "contract_attachment_list",
                                rules: [
                                  {
                                    required: true,
                                    message: "Attachments cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("tips.agreement_between_tip")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "el-link",
                                    {
                                      staticClass: "check-class",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.showContractModal },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("components.view")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.form.contract_attachment_list
                                ? _vm._l(
                                    _vm.form.contract_attachment_list,
                                    function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.fileName,
                                          staticClass: "file-container",
                                        },
                                        [
                                          _vm.isImg(item.fileName)
                                            ? _c("img", {
                                                directives: [
                                                  {
                                                    name: "viewer",
                                                    rawName: "v-viewer",
                                                  },
                                                ],
                                                staticClass:
                                                  "content-img reply-content-img",
                                                attrs: {
                                                  src: item.absolutePath,
                                                  alt: "",
                                                },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "reply-content-file",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onClickIcon(
                                                        item.fileName,
                                                        item.absolutePath
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.fileName))]
                                              ),
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onClickRemoveBtn(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("components.delete")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                              _c(
                                "UploadFile",
                                _vm._g(
                                  {
                                    attrs: {
                                      "accept-type": "*",
                                      "file-dir": "DISBURSEMENT_FILE",
                                    },
                                    on: {
                                      templateFileSuccess:
                                        _vm.templateFileSuccess,
                                      change: _vm.contractAttachmentListChange,
                                    },
                                  },
                                  _vm.$listeners
                                )
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.remark"),
                                prop: "remark",
                                rules: [
                                  {
                                    required: true,
                                    message: "Remark cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "tips.large_value_beneficiary_remark_tip"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Enter your message here",
                                  type: "textarea",
                                  autocomplete: "off",
                                  maxlength: "256",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: {
                    click: function ($event) {
                      return _vm.onClickSubmitBtn()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ContractDescriptionModal", { ref: "ContractDescriptionModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }